declare namespace $ {

	export class $mol_icon_playlist_plus extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=plus.view.tree.d.ts.map